import React, { useEffect, useCallback, useState} from 'react';
import {convertNumberToList, convertListToNumber} from 'effects/midi/scripting/beat.js';
import {connect} from 'react-redux';

const MidiGateEffect = ({effect, steps}) => { 
    if (typeof steps === "number") {
        steps = convertNumberToList(steps);
    }
    const toggle = useCallback((step, val) => {
        let _steps = [...steps];
        _steps[step] = !val;
        effect.stepsParameter.set(convertListToNumber(_steps));
    }, [effect, steps]);

    return (
        <div className="gate-steps">
        {steps.map(
            (x,i) => <div key={i} onClick={() => toggle(i,x)} className={x ? "on gate-step" : "gate-step"}></div>)}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      steps: props.effect.stepsParameter.get()
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MidiGateEffect);
